import { SelectableBox } from "@src/appV2/redesign/components/SelectableBox";
import { WORKER_REFERRALS_SHARE_LINK_PATH_FULL } from "@src/appV2/Referral/path";

export function WorkerReferralCta() {
  return (
    <SelectableBox
      withCallToActionIcon
      href={WORKER_REFERRALS_SHARE_LINK_PATH_FULL}
      startIconType="user-add"
    >
      Refer a professional
    </SelectableBox>
  );
}
